export type FilterLocation = 'table' | 'global page' | 'global explore';

/** Returns the analytics context to spread into Filter Change / Filter Viewed. */
export function useFilterAnalytics(location: FilterLocation): { location: FilterLocation; type: 'open' } {
	return { location, type: 'open' };
}
